import React, { Component } from 'react'
import { navigate } from '@reach/router'
import styled from 'styled-components'
import Calendar from 'react-calendar'
import { getCurrentUser } from '../../services/auth'
import { device } from '../Breakpoints'
import View from './View'
import { FiChevronRight, FiChevronLeft } from 'react-icons/fi'
import { colors } from '../Colors'
import ItemCalendario from './ItemCalendario'
import VejaTambem from '../../components/VejaTambem'
import header from '../../img/agendamento-visita-topo-b.jpg'
import moment from 'moment'

const Container = styled.section`
  width: 100%;
  margin-bottom: 2em;
  .pageHeader {
    margin: auto;
    width: 100%;
    display: block;
  }
  section.center {
    margin-top: 2em;
  }
  .react-calendar__tile, .react-calendar__tile.react-calendar__tile--now {
    cursor: pointer;
    border-radius: 10px;
    box-sizing: border-box;
    font-family: 0.6em;
    width: 115px;
    margin: 1em;
    flex-basis: auto !important;
    max-height: auto !important;
    line-height: 60px;
    border: none;
    position: relative;
    background: #b5dcce;

    abbr {
      position: absolute;
      top: -10px;
      left: 10px;
      color: #ffffff;
    }
    span {
      color: #539e9f;
      text-transform: uppercase;
      font-family: 'Santral SemiBold', Arial, Helvetica, sans-serif;
    }
  }
  .react-calendar__month-view__weekdays__weekday {
    text-align: center;
    justify-content: space-between;
    margin: 0.4em;
  }
  .react-calendar__tile--now {
    background: #000000;
    color: #ffffff;
  }
  .react-calendar__month-view__days {
    justify-content: space-between;
  }
  button[type='button']:disabled {
    background: #EAEAEA;
    abbr {
      color: #b1b1b1;
    }
    span {
      color: #b1b1b1;
    }
  }
  
  .react-calendar__tile--active {
    background: ${colors.laranjaGradienteReverso};
    abbr {
      color: #ffffff;
    }
    span {
      color: #ffffff;
    }
  }
  button[type='button']:disabled.react-calendar__navigation__arrow {
   /* display: none;*/
  }
  .react-calendar__month-view__days__day--neighboringMonth {
    abbr {
      display: none;
    }
    background: none !important;
    border: 1px solid #eaeaea;
  }
  .react-calendar__navigation {
    justify-content: center;
    flex-wrap: wrap;
  }
  .react-calendar__navigation__label {
    font-size: 30px;
    text-transform: capitalize;
    color: #fa7272;
    background: none;
    border: none;
    flex-grow: 0 !important;
    width: 100%;
}
  }
  .react-calendar__month-view__weekdays__weekday{
    abbr{
      font-size: 12px;
      text-transform: uppercase;
      color: #4A4A4A;
    }
    abbr[title] {
      text-decoration:none!important;      
    }
  }
  .react-calendar__navigation__arrow {
    color: #fa7272;
    background: none;
    border: none;
    font-size: 12px;
    margin-top:10px;
    margin-bottom:10px;
    text-transform: uppercase;
    cursor: pointer;
    .next {
      margin-left: 20px;
      svg {
        vertical-align: top;
        margin-left: 15px;
      }
    }
    .prev {
      margin-right: 20px;
      svg {
        vertical-align: top;
        margin-right: 15px;
      }
    }
  }
  .react-calendar__navigation__next2-button,
  .react-calendar__navigation__prev2-button {
    display: none;
  }
  .buttons {
    width: 500px;
    margin: auto;
    text-align: center;
    button {
      margin: 20px;
    }
  }
`

class Calendario extends Component {
  state = {
    date: new Date(),
    convenio: window.history.state,
  }
  onChange = date => this.setState({ date })
  daySelector = (value, event) => {
    this.setState({ day: moment(value).format('YYYY-MM-DD') })
  }

  nextPage = () => {
    if (this.state.day) {
      navigate('/agendamento-de-visitas/horarios', {
        state: this.state,
        replace: true,
      })
    } else {
      alert('Por favor, selecione um dia.')
    }
  }

  render() {
    const { name } = getCurrentUser()
    //const handleLogout = () => logout()
    const crumbs = [
      { id: 1, link: '/', title: 'Home', icon: true },
      { id: 2, link: '#', title: 'Agendamento', icon: true },
    ]

    function PrevArrow() {
      return (
        <div className="prev">
          <FiChevronLeft size="1.1em" /> Mês Anterior
        </div>
      )
    }

    function NextArrow() {
      return (
        <div className="next">
          Próximo mês <FiChevronRight size="1.1em" />
        </div>
      )
    }

    return (
      <Container>
        <View>
          <p>Selecione uma data para a sua visita:</p>
          <div className="center">
            <Calendar
              onChange={this.onChange}
              value={this.state.date}
              minDate={new Date()}
              maxDetail="month"
              defaultView="month"
              calendarType="US"
              formatShortWeekday={(locale, date) => moment(date).format('dddd')}
              prevLabel={<PrevArrow />}
              nextLabel={<NextArrow />}
              navigationLabel={({ label }) => `${label.replace('de', '')}`}
              tileContent={ItemCalendario}
              returnValue="end"
              onClickDay={(value, event, end) => {
                this.daySelector(value, event)
              }}
            />
            <div className="buttons">
              <button
                type="button"
                onClick={() => navigate('/agendamento-de-visitas/convenios')}
                className="button prev"
              >
                voltar
              </button>
              <button
                type="button"
                onClick={() => this.nextPage()}
                className="button next"
              >
                Próximo
              </button>
            </div>
          </div>
        </View>
        <VejaTambem />
      </Container>
    )
  }
}

export default Calendario
